import { render } from "./Index.vue?vue&type=template&id=4a0f4e81"
import script from "./Index.vue?vue&type=script&lang=js"
export * from "./Index.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/vhosts/elyosdigital.com/_build/workspace/MySchool/myschool.elyosdigital.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/pages/categorie/Index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4a0f4e81"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4a0f4e81', __exports__)) {
    console.log('reload')
    api.reload('4a0f4e81', __exports__)
  }
  
  module.hot.accept("./Index.vue?vue&type=template&id=4a0f4e81", () => {
    console.log('re-render')
    api.rerender('4a0f4e81', render)
  })

}


export default __exports__